import { Component } from 'react';
import { Alert } from "react-bootstrap";
import { observe } from 'mobx';
import ApplicationState from "../mobx/ApplicationState";

import "./AlertList.scss";

export class AlertList extends Component {

    constructor(props) {
        super(props);

        this.state = {
        }
    }

    componentDidMount() {
        this.applicationStateCleanup = observe(ApplicationState, () => { 
            this.forceUpdate()
        });
    }

    componentWillUnmount() {
        if (this.applicationStateCleanup) {
            this.applicationStateCleanup();
        }
    }

    render() {
        return (
            <div className="alert-list-container">
                <div className="alert-list">
                    {ApplicationState.alerts.map(alert => {
                        return <Alert 
                        className={alert.classes.join(' ')}
                        key={alert.id} 
                        variant={alert.variant} 
                        dismissible={alert.options.dismissable}
                        onClose={() => ApplicationState.removeAlert(alert.id)}>
                            {alert.message}
                        </Alert>
                    })}
                </div>
            </div>
        );
    }
}